package com.milta.core.localization.translations.en

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Cancel",
    confirm = "Confirm",
    save = "Save",
    delete = "Delete",
    back = "Back",
    loading = "Loading…",
    retry = "Retry",
    creationInProgressDoNotClose = "Creation in progress, do not close the window",
    processingStepSent = "Document sent",
    processingStepReading = "Reading the document",
    processingStepFinding = "Finding deliveries",
    processingStepChecking = "Checking addresses",
    processingUsualDuration = "Usually 20 to 40 seconds. Stay on this screen, we'll take care of the rest.",
    processingLongWait = "Your document contains a lot of information, so the analysis is taking a bit longer than usual. Everything is working, we're still going.",
    processingInProgressSince = "In progress for %1",
    processingFinishedIn = "Finished in %1",
    processingDeliveriesFound = "%1 deliveries found",
    processingDeliveriesFoundOne = "1 delivery found",
    processingAddressesChecked = "%1 of %2 addresses",
    addressVerifiedBadge = "✓ Address verified",
    addressNeedsReviewBadge = "⚠ Address needs review",
    addressFoundLine = "Found: %1",
    language = "Language",
    welcomeTitle = "Welcome to Milta",
    welcomeSubtitle = "Your smart delivery assistant",
    alreadyHaveAccount = "I already have an account",
    createAccount = "Create an account",
    continueWithGoogle = "Continue with Google",
    continueWithApple = "Continue with Apple",
    oauthErrorGeneric = "Something went wrong while signing in. Please try again.",
    oauthAppleWebComingSoon = "Apple sign-in is coming soon on web.",
    oauthDriverAccountNotAllowedOnWeb = "Driver accounts can't access the web dashboard. Please sign in from the mobile app.",
    oauthAccountNotFoundOnWeb = "No Milta account was found for this Google account.",
    errorOffline = "No internet connection.",
    navTourneesDuJour = "Today's routes",
    navAjouterUneTournee = "Add a route",
    navHistoriqueDesPreuves = "Delivery history",
    navParametres = "Settings",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "No deliveries yet",
    noDeliveriesYetSubtitle = "Tap \"Add deliveries\" to add some",
    optimizationUnavailableExplanation = "Would you like to create the route without optimizing, or try again?",
    createWithoutOptimizationAction = "Create without optimizing",
    gpsAppSheetTitle = "Choose a navigation app",
    addressSearchingLabel = "Searching…",
    clearTimeFieldAction = "Clear",
    clearTimeFieldConfirmTitle = "Clear this time?",
    clearTimeFieldConfirmMessage = "The current time will be removed. You can set a new one at any time.",
    updateRequiredTitle = "Update required",
    updateRequiredMessage = "A new version of Milta is available. Update the app to keep using it.",
    updateInstalledVersionLabel = "Installed",
    updateAvailableVersionLabel = "Available",
    updateNowButton = "Update",
    updateDataKeptNote = "Your routes and deliveries are kept.",
    updateSendingPendingOne = "Sending 1 delivery validated offline…",
    updateSendingPendingMany = "Sending {count} deliveries validated offline…",
)
